export enum CustomerType {
    family = 'family',
    partner = 'partner',
    company = 'company'
}